import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useFilter } from "../../filterContext/filterContext";
import { useNavigate } from 'react-router-dom';

import propertyTypeImg1 from '../../../assets/images/propertyType/residential-apartment-icon.webp'
import propertyTypeImg2 from '../../../assets/images/propertyType/residential-land-icon.webp'
import propertyTypeImg3 from '../../../assets/images/propertyType/residential-house-villa-icon.webp'
import propertyTypeImg4 from '../../../assets/images/propertyType/commercial-shop-icon.webp'
import propertyTypeImg5 from '../../../assets/images/propertyType/commercial-office-icon.webp'
import propertyTypeImg6 from '../../../assets/images/propertyType/commercial-land-icon.webp'
import propertyTypeImg7 from '../../../assets/images/propertyType/commercial-building-icon.webp'
import propertyTypeImg8 from '../../../assets/images/propertyType/commercial-other-icon.webp'
import propertyTypeImg9 from '../../../assets/images/propertyType/industrial-building-icon.webp'
import propertyTypeImg10 from '../../../assets/images/propertyType/industrial-land-icon.webp'
import propertyTypeImg11 from '../../../assets/images/propertyType/agricultural-land-icon.webp'

function PropertyType() {
    const { saveFilterData } = useFilter();
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const handleClick = (e,text) => {
        console.log(text)
        e.preventDefault();
        const filterData = {
            propertyType: [text],  // Only save the selected property type as the first value in the array
            purpose: "",  // Ensure purpose is either set or empty
            selectedDistrict: "",  // Ensure district is either set or empty
            selectedTown: ""  // Ensure town is either set or empty
        };
        saveFilterData(filterData);
        //saveFilterData({ propertyType: text });  // Set the property type in context
        navigate("/keralaplots/properties");
    };

    // Simulate loading with a timeout (you can replace it with actual data fetch)
    useEffect(() => {
        setIsLoading(false);
    }, []);

    return (
        <>
            <section id="propertyType">
                <div className="container">
                    <h2 className="title">Property Type</h2>
                    <div className="propertyTypeMain">
                        {isLoading ? (
                            <div className='SkeletonLoader'>
                                <Skeleton />
                                <Skeleton />
                                <Skeleton />
                                <Skeleton />
                                <Skeleton />
                                <Skeleton />
                            </div>
                        ) : (
                            <>
                                <a href="" className="propertyTypeBox" onClick={(e) => handleClick(e,'Residential Apartment')}>
                                    <div className="propertyTypeBoxThumbnail">
                                        <img src={propertyTypeImg1} alt="" />
                                    </div>
                                    <div className="propertyTypeBoxDetails">
                                        <p>Residential Apartment</p>
                                    </div>
                                </a>
                                <a href="" className="propertyTypeBox" onClick={(e) => handleClick(e,'Residential Land')}>
                                    <div className="propertyTypeBoxThumbnail">
                                        <img src={propertyTypeImg2} alt="" />
                                    </div>
                                    <div className="propertyTypeBoxDetails">
                                        <p>Residential Land</p>
                                    </div>
                                </a>
                                <a href="" className="propertyTypeBox" onClick={(e) => handleClick(e,'Residential House/Villa')}>
                                    <div className="propertyTypeBoxThumbnail">
                                        <img src={propertyTypeImg3} alt="" />
                                    </div>
                                    <div className="propertyTypeBoxDetails">
                                        <p>Residential House/Villa</p>
                                    </div>
                                </a>
                                <a href="" className="propertyTypeBox"  onClick={(e) => handleClick(e,'Commercial Shop')}>
                                    <div className="propertyTypeBoxThumbnail">
                                        <img src={propertyTypeImg4} alt="" />
                                    </div>
                                    <div className="propertyTypeBoxDetails">
                                        <p>Commercial Shop</p>
                                    </div>
                                </a>
                                <a href="" className="propertyTypeBox" onClick={(e) => handleClick(e,'Commercial Office')}>
                                    <div className="propertyTypeBoxThumbnail">
                                        <img src={propertyTypeImg5} alt="" />
                                    </div>
                                    <div className="propertyTypeBoxDetails">
                                        <p>Commercial Office</p>
                                    </div>
                                </a>
                                <a href="" className="propertyTypeBox" onClick={(e) => handleClick(e,'Commercial Land')}>
                                    <div className="propertyTypeBoxThumbnail">
                                        <img src={propertyTypeImg6} alt="" />
                                    </div>
                                    <div className="propertyTypeBoxDetails">
                                        <p>Commercial Land</p>
                                    </div>
                                </a>
                                <a href="" className="propertyTypeBox" onClick={(e) => handleClick(e,'Commercial Building')}>
                                    <div className="propertyTypeBoxThumbnail">
                                        <img src={propertyTypeImg7} alt="" />
                                    </div>
                                    <div className="propertyTypeBoxDetails">
                                        <p>Commercial Building</p>
                                    </div>
                                </a>
                                <a href="" className="propertyTypeBox" onClick={(e) => handleClick(e,'Commercial Other')}>
                                    <div className="propertyTypeBoxThumbnail">
                                        <img src={propertyTypeImg8} alt="" />
                                    </div>
                                    <div className="propertyTypeBoxDetails">
                                        <p>Commercial Other</p>
                                    </div>
                                </a>
                                <a href="" className="propertyTypeBox" onClick={(e) => handleClick(e,'Industrial Building')}>
                                    <div className="propertyTypeBoxThumbnail">
                                        <img src={propertyTypeImg9} alt="" />
                                    </div>
                                    <div className="propertyTypeBoxDetails">
                                        <p>Industrial Building</p>
                                    </div>
                                </a>
                                <a href="" className="propertyTypeBox" onClick={(e) => handleClick(e,'Industrial Land')}>
                                    <div className="propertyTypeBoxThumbnail">
                                        <img src={propertyTypeImg10} alt="" />
                                    </div>
                                    <div className="propertyTypeBoxDetails">
                                        <p>Industrial Land</p>
                                    </div>
                                </a>
                                <a href="" className="propertyTypeBox" onClick={(e) => handleClick(e,'Agricultural Land')}>
                                    <div className="propertyTypeBoxThumbnail">
                                        <img src={propertyTypeImg11} alt="" />
                                    </div>
                                    <div className="propertyTypeBoxDetails">
                                        <p>Agricultural Land</p>
                                    </div>
                                </a>
                            </>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
}

export default PropertyType;
